import { functions } from "config/firebaseConfig";

export const sendProtest = (
    protest,
    setSubmitting,
    resetForm,
    enqueueSnackbar
) => {
    return functions
        .httpsCallable("protest-sendProtest")(protest)
        .then(() => {
            setSubmitting(false);
            enqueueSnackbar("Protesto enviado", {
                variant: "success",
            });
            resetForm();
        })
        .catch((error) => {
            console.error(error.code);
            setSubmitting(false);

            let errorMessage = "Erro ao enviar protesto";
            if (error.code === "permission-denied") {
                errorMessage =
                    "Você não tem permissão para abrir protesto nesse campeonato";
            }
            if (error.code === "deadline-exceeded") {
                errorMessage =
                    "Prazo para envio de protesto encerrado para esta etapa";
            }
            enqueueSnackbar(errorMessage, {
                variant: "error",
            });
        });
};
